import { render, staticRenderFns } from "./ExpenseCreateEditModal.vue?vue&type=template&id=4bf130dc&scoped=true"
import script from "./ExpenseCreateEditModal.vue?vue&type=script&lang=js"
export * from "./ExpenseCreateEditModal.vue?vue&type=script&lang=js"
import style0 from "./ExpenseCreateEditModal.vue?vue&type=style&index=0&id=4bf130dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf130dc",
  null
  
)

export default component.exports